var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconForward15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.93,4.93c3.89-3.89,10.19-3.91,14.1-.03v-2.22h1.35v4.73h-4.73v-1.35h2.63c-1.63-1.73-3.9-2.71-6.28-2.71-4.77,0-8.65,3.88-8.65,8.65s3.88,8.65,8.65,8.65,8.65-3.88,8.65-8.65h1.35c0,5.52-4.47,10-10,10-2.65,0-5.2-1.05-7.07-2.93-3.91-3.9-3.91-10.24,0-14.14,0,0,0,0,0,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.5,15.46v-5.69h-.03l-1.8,1.22v-1.31l1.82-1.26h1.47v7.05h-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.25,15.58c-.51,0-.96-.09-1.34-.27-.38-.18-.69-.43-.91-.74s-.35-.66-.38-1.05v-.07s1.36,0,1.36,0v.03c.05.18.12.33.24.48.12.14.26.26.44.34s.38.12.61.12c.26,0,.48-.05.68-.16.2-.11.35-.26.46-.45s.17-.41.17-.66h0c0-.26-.06-.48-.17-.66s-.27-.34-.46-.44-.42-.16-.67-.16c-.18,0-.34.03-.5.08-.15.05-.29.12-.41.22-.07.05-.13.11-.19.18-.06.07-.11.14-.15.21h-1.28l.32-4.14h4.5v1.17h-3.33l-.17,1.99h.03c.1-.16.23-.3.38-.41.16-.11.34-.2.54-.26.2-.06.42-.09.66-.09.45,0,.85.1,1.19.29.34.2.62.47.82.81s.3.74.3,1.18h0c0,.5-.12.93-.34,1.3-.23.37-.55.66-.96.87s-.88.31-1.42.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForward15);
export default __webpack_public_path__ + "static/media/icon-forward-15.7a0f3a02.svg";
export { ForwardRef as ReactComponent };